.root {
  width: 24px;
  height: 24px;
}
